<template>
  <div class="LibSearchInput">
    <el-input
      v-model="keyWorde"
      :placeholder="placeholder"
      maxlength="100"
      @keyup.enter.native="handleSearch"
    ></el-input>
    <el-button type="primary" round @click="handleSearch"> <i class="iconfont icon-sousuo"></i> 搜索</el-button>
    <p class="fixedBtn" @click="handleSearch"><i class="iconfont icon-sousuo"></i></p>
  </div>
</template>

<script>
import { OLD_SEARCH_PAGE } from "../../utils/constants/constants";
import { DEED_MAP, OID_MAP } from "../../utils/constants/constants.track";

export default {
  name: "LibSearchInput",
  props: ["placeholder", "oid", "extend"],
  data() {
    return {
      keyWorde: "",
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters["basic/isLogin"];
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleSearch() {
      const qUrl = this.isLogin ? `&q=${encodeURIComponent(this.keyWorde)}` : "";
      const keywordParam = this.isLogin ? "keyword" : "keywords";
      console.log(this.extend);
      if (this.oid) {
        this.$track(DEED_MAP.CLICK, this.oid, {
          extendinfo: this.extend,
        });
      }else {
        this.$track(DEED_MAP.CLICK, OID_MAP.HOME_SEARCH_CLICK);
      }
      window.open(`${OLD_SEARCH_PAGE()}?${keywordParam}=${encodeURIComponent(this.keyWorde)}${qUrl}`);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/config";

.LibSearchInput {
  top: 16px;
  width: 270px;
  transform: translateX(0);
  left: 21%;
  margin: 0 auto;
  position: absolute;
  .el-input {
    ::v-deep .el-input__inner {
      font-size: 14px;
      height: 34px;
      padding-left: 16px;
      padding-right: 28px;
      border-radius: 31px;
      background: #fff;
    }
  }
  .fixedBtn {
    position: absolute;
    top: 8px;
    right: 16px;
    display: none;
    cursor: pointer;
    &:hover {
      i {
        color: $theme-color;
      }
    }
    i {
      font-size: 14px;
      color: #a3a6ab;
    }
  }

  .el-button {
    position: absolute;
    top: 4px;
    right: 4px;
    height: 50px;
    border-radius: 30px;
    display: none;
    &:hover {
      background: #f66d59;
      border-color: #f66d59;
    }
  }
}
</style>
